import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
  useTranslation,
} from "@ncino/pax-ui";
import ncinoLogo from "@/assets/images/ncino-logo-mono-blue-RGB.png";

interface OrderFormStepProps {
  onSignNow: () => void;
  onEnterWithoutSigning: () => void;
}

export function OrderFormStep({ onSignNow, onEnterWithoutSigning }: OrderFormStepProps) {
  const { t } = useTranslation();

  return (
    <>
      <DialogContent sx={{ "&&": { pt: 6 }, pb: 5, px: 7 }}>
        <Stack spacing={2} alignItems="start">
          <Box
            component="img"
            src={ncinoLogo}
            alt={t("agreementGate.logoAlt")}
            sx={{ height: 28, width: "auto", display: "block" }}
          />
          <Typography id="agreement-gate-title" variant="h4" fontWeight="fontWeightSemiBold">
            {t("orderFormStep.title")}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t("orderFormStep.message")}
          </Typography>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 7, pb: 4, pt: 4, backgroundColor: "grey.100" }}>
        <Stack direction="column" spacing={2} sx={{ width: "100%" }}>
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={onSignNow}
            data-testid="order-form-sign-now"
          >
            {t("orderFormStep.signNow")}
          </Button>
          <Button
            fullWidth
            size="large"
            variant="outlined"
            onClick={onEnterWithoutSigning}
            data-testid="order-form-enter-without-signing"
          >
            {t("orderFormStep.enterWithoutSigning")}
          </Button>
        </Stack>
      </DialogActions>
    </>
  );
}
